import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.string.starts-with";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.number.constructor";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import { isNullOrEmpty } from '@/utils/vuex';
import ApiService from '@/services/apiService';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
export default {
  name: 'IsHeatMonitoringStateEdit',
  props: {
    // the current edited state
    value: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    twinType: {
      type: String,
      required: false,
      default: null
    },
    // is this an edit, create, or readonly?
    mode: {
      type: String,
      required: false,
      default: function _default() {
        return 'edit';
      }
    },
    tenantId: {
      type: Number,
      required: true
    },
    // the original twin(/virtual-device)-model
    // to be used by some components for additional requesting data
    twinModel: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    dataSources: {
      type: Array,
      required: true
    },
    bridgeConfigs: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    },
    otherStates: {
      type: Array,
      required: false,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    var _this = this;

    return {
      lclModel: {},
      aggregatedStateValue: '',
      innerFormIsValid: false,
      wholeFormIsValid: false,
      requiredRule: [function (v) {
        return !!v || _this.$i18n_t('Common.fieldRequired');
      }],
      rewireMeterDialog: false,
      meterId: -1,
      conflictMeterPointId: -1,
      // since the meter is already "linked" when the dialog appears, force-refresh the entire source-edit component
      // so the re-selection takes place
      redrawSourceItemKey: 0
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme', 'permissions'])), {}, {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    filteredDataSources: function filteredDataSources() {
      var filterSourcesGeneric = ['iothub', 'iothub-aggregate', 'random'];
      var filterBridges = this.twinType === 'virtualDevice' ? [].concat(filterSourcesGeneric, ['timeseries-aggregate', 'aggregate']) : [].concat(filterSourcesGeneric, ['bridge', 'virtual-device-aggregate']);
      return this.dataSources.filter(function (ds) {
        return filterBridges.indexOf(ds.type) < 0;
      });
    }
  }),
  watch: {
    value: function value() {
      this.lclModel = cloneDeep(this.value);
      this.updateBindingType();
    }
  },
  created: function created() {
    this.lclModel = cloneDeep(this.value);

    if (this.mode === 'create') {
      this.lclModel = {
        value: {},
        properties: {
          valueType: 'number'
        }
      };
    }

    if (!get(this.lclModel, 'properties.binding')) {
      this.lclModel.properties = Object.assign({}, this.lclModel.properties, {
        binding: {
          type: 'none',
          options: {
            aggregateStateBindingIds: []
          }
        }
      });
    }

    this.updateBindingType();
    this.changedBindingType();
  },
  methods: {
    updateBindingType: function updateBindingType() {
      // during creation of a meter-point, the `consumption_current` is not linked to a meter/virtual device yet,
      // so it is created as a static state. While editing it tho, have `virtual-device` as source-type preselected then
      if (this.lclModel.key === 'consumption_current') {
        this.lclModel.properties.binding.type = 'virtual-device';
      }

      if (this.lclModel.key === 'consumption_total') {
        this.lclModel.properties.binding.type = 'aggregate';
      }
    },
    matchDataSource: function matchDataSource(type) {
      return this.dataSources.find(function (d) {
        return d.type === type;
      }) || {};
    },
    changedBindingType: function changedBindingType() {
      var _this2 = this;

      if ( // only update the valueType automatically if the binding-type was changed JUST NOW
      // it changedBindingType is also called on create/init
      get(this.value, 'properties.valueType') === undefined || get(this.value, 'properties.binding.type') !== this.lclModel.properties.binding.type) {
        if (this.lclModel.properties.binding.type === 'random') {
          this.lclModel.properties.valueType = 'number';
        } else if (['aggregate', 'iothub-aggregate', 'virtual-device-aggregate'].indexOf(this.lclModel.properties.binding.type) >= 0) {
          this.lclModel.properties.valueType = 'json';
        }
      }

      if (this.lclModel.properties.binding.type === 'virtual-device') {
        this.$nextTick(function () {
          var sourceEditRefs = get(_this2, '$refs.sourceEdit.$refs') || {};
          sourceEditRefs.virtualDeviceBindingEdit.virtualDeviceFetchVariable = 'meters';

          sourceEditRefs.virtualDeviceBindingEdit.fetchRequest = function () {
            return ApiService.isHeatMonitoringFetch(_this2, 'meters', 0, 50, [{
              or: [{
                variable: 'title',
                search: sourceEditRefs.virtualDeviceBindingEdit.virtualDeviceSearch
              }, {
                variable: 'id',
                search: sourceEditRefs.virtualDeviceBindingEdit.virtualDeviceSearch
              }]
            }, // only offer those meters that have no meter-point assigned yet
            {
              variable: 'meterPointId',
              search: null
            }], null, null, ['bare']);
          };
        });
      }

      this.validateForm();
    },
    validateForm: function validateForm() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.innerFormIsValid = _this3.$refs.form.validate();
        var sourceEditRefs = get(_this3, '$refs.sourceEdit.$refs') || {};

        if (_this3.lclModel.properties.binding.type === 'bridge') {
          _this3.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.bridgeBindingEdit) && sourceEditRefs.bridgeBindingEdit.formIsValid;
        } else if (_this3.lclModel.properties.binding.type.startsWith('iothub')) {
          _this3.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.iothubBindingEdit) && sourceEditRefs.iothubBindingEdit.formIsValid;
        } else if (_this3.lclModel.properties.binding.type.startsWith('virtual-device')) {
          _this3.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.virtualDeviceBindingEdit) && sourceEditRefs.virtualDeviceBindingEdit.formIsValid;
        } else if (_this3.lclModel.properties.binding.type === 'aggregate') {
          _this3.wholeFormIsValid = !isNullOrEmpty(sourceEditRefs.aggregateBindingEdit) && sourceEditRefs.aggregateBindingEdit.aggregateStateLoops === false;
        } else {
          _this3.wholeFormIsValid = true;
        }

        _this3.wholeFormIsValid = _this3.wholeFormIsValid && _this3.innerFormIsValid;
      });
    },
    // ----
    // NIOTA OR IOTHUB
    // ----
    noPermissionError: function noPermissionError(error) {
      this.close(error || 'NOT AUTHORIZED FOR THIS STATE');
    },
    resetMeterBinding: function resetMeterBinding() {
      // NOTE: the new virtual-device/meter-id is not written into `lclModel.properties.binding.options.virtualDevice.id`
      // until the `save()` method of the component is called. So just simply force-reloading the component also resets it
      // for that, the key for `core-dtwin-state-edit-source` is increased, forcing it to be re-created
      this.redrawSourceItemKey++;
      this.rewireMeterDialog = false;
    },
    bridgeBindingChanged: function bridgeBindingChanged(val) {
      var _this4 = this;

      if (val.identifier && parseInt(val.identifier) !== this.meterId) {
        this.meterId = parseInt(val.identifier);
        ApiService.isHeatMonitoringCheckMeterDependency(this, val.identifier).then(function (res) {
          if (res.id !== null && res.id !== _this4.lclModel.dtwinId && // only show warning popup, if the meter is not already wired and persisted
          // DO show it tho if the meter is changed. But as via `virtualDeviceBindingEdit.fetchRequest`
          // (above in changedBindingType), only meters are fetched that are NOT wired yet, so this
          // should actually never even occur
          get(_this4.lclModel, 'properties.binding.options.virtualDevice.id') !== _this4.meterId) {
            _this4.conflictMeterPointId = res.id;
            _this4.rewireMeterDialog = true;
          }
        }).catch(function (error) {
          console.error(error);
        });
      }

      var variable = val.variable;
      var valueType = val.valueType;
      var value = val.value;

      if (!!variable) {
        if (!!valueType && isNullOrEmpty(this.lclModel.properties.unit)) {
          this.lclModel.properties.unit = valueType;
        }

        if (!!value) {
          this.lclModel.value.value = value;
        }

        this.lclModel = cloneDeep(this.lclModel);
      }

      this.validateForm();
    },
    // -----
    // AGGREGATE
    // -----
    aggregatedStateValueChanged: function aggregatedStateValueChanged(aggregatedStateValue) {
      this.aggregatedStateValue = aggregatedStateValue;
    },
    handleSubmit: function handleSubmit() {
      this.$refs.stateValueComp.saveState();
      var sourceEditRefs = get(this, '$refs.sourceEdit.$refs') || {};

      if (this.lclModel.properties.binding.type === 'bridge') {
        if (sourceEditRefs.bridgeBindingEdit && sourceEditRefs.bridgeBindingEdit.saveState) {
          sourceEditRefs.bridgeBindingEdit.saveState();
        }
      } else if (this.lclModel.properties.binding.type.startsWith('iothub')) {
        sourceEditRefs.iothubBindingEdit.saveState();
      } else if (this.lclModel.properties.binding.type.startsWith('virtual-device')) {
        sourceEditRefs.virtualDeviceBindingEdit.saveState();
      } else if (this.lclModel.properties.binding.type === 'aggregate') {
        sourceEditRefs.aggregateBindingEdit.saveState();
      }

      this.$emit('save', cloneDeep(this.lclModel));
    },
    close: function close(errorMessage) {
      this.$emit('close', errorMessage);
    }
  }
};